import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { serverPageType, ServerPage } from '../types/server-page'
import { ServerOrder } from '../types/server-order'
import { Context } from '../shared'
import { ServerPagingArgs, serverPagingArgs } from '../types/server-paging-args'
import { ServerOrderField } from '../types/server-order-field'
import { normalizeServer } from './helpers/server'
import {
  appendServerFiltersToBody,
  ContrastQueryParameters
} from '../endpoint-helpers'

const orderMap: { [key in ServerOrderField]: string } = {
  NAME: 'serverName',
  ENVIRONMENT: 'environment',
  LAST_SEEN: 'lastActivity',
  VERSION: 'version'
}

export function appendSortToParams(
  params: ContrastQueryParameters,
  orderBy: ServerOrder | undefined
) {
  if (orderBy) {
    const { field, direction } = orderBy
    params.append(
      'sort',
      `${direction === 'DESC' ? '-' : ''}${orderMap[field]}`
    )
  }
}

export const servers: GraphQLFieldConfig<any, Context, ServerPagingArgs> = {
  description: 'Get a page of servers',
  type: new GraphQLNonNull(serverPageType),
  args: serverPagingArgs,
  async resolve(_source, args, context): Promise<Partial<ServerPage>> {
    const { offset, limit, organizationID, orderBy, filters } = args

    const params = new ContrastQueryParameters()
    params.append('offset', offset)
    params.append('limit', limit)
    params.append(
      'expand',
      'applications,server_license,inspect_app_instrumentation,assess_protect_status_locked'
    )
    appendSortToParams(params, orderBy)

    const mappedFilters = appendServerFiltersToBody(filters)

    const { servers = [], count: total } = await context.connector.post(
      `/${organizationID}/servers/filter?${params}`,
      mappedFilters
    )

    return {
      total,
      items: servers.map(normalizeServer)
    }
  }
}
